import {FileBrowerPreferences} from 'constants/FileBrowserConstants';
import preferences from 'Preferences';

export const AVAILABLE_PAGE_SIZES = [5, 10, 25, 50, 100, 500, 1000];
export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE_PREFERENCE = 100;

/*
 * Return the page size to use when loading results.
 */
export function getSelectedPageSize(): number {
  const savedFilterValue = preferences.get(FileBrowerPreferences.PAGE_SIZE);
  return savedFilterValue == null ? DEFAULT_PAGE_SIZE : savedFilterValue;
}

export function setPageSizePreference(pageSize: number): void {
  // To avoid users unintentionally leaving their page size preference on a
  // large (i.e. slow) setting, only persist it when it is below a threshold
  if (pageSize > MAX_PAGE_SIZE_PREFERENCE) {
    return;
  }

  preferences.set(FileBrowerPreferences.PAGE_SIZE, pageSize);
}
